<template>
  <div class="qr-preview-shadow qr-preview-popup min-h-screen flex flex-col" v-if="show" @click.self="close">
    <div class="qr-inner flex-col flex p-6">
      <div class="content flex-col flex">
        <h2 class="grey_text title">QR Code Preview</h2>

        <div class="preview_wrapper">
          <img v-if="imageDataUrl" :src="imageDataUrl" alt="QR code preview" class="preview_img" />
        </div>

        <div class="actions border-t border-gray-200 pt-4 flex w-full justify-end">
          <button
              @click="close"
              class="this_button mr-3 py-3 px-4 bg-gray-200 border border-gray-300">
            Close
          </button>
          <button
              @click="download"
              class="this_button py-3 px-4 border text_chameleon bg-green-custom hover:bg-gray-200 border-green-custom">
            Download
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QrCodePreviewModal",
  data() {
    return {
      show: false,
      imageDataUrl: '',
      filename: 'qr.png',
    };
  },
  methods: {
    open({ imageDataUrl, filename } = {}) {
      this.imageDataUrl = imageDataUrl || '';
      this.filename = filename || 'qr.png';
      this.show = true;
    },
    close() {
      this.show = false;
      this.imageDataUrl = '';
    },
    download() {
      if (!this.imageDataUrl) return;
      const link = document.createElement('a');
      link.href = this.imageDataUrl;
      link.download = this.filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-preview-shadow {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.39);
  z-index: 1000;
}
.qr-preview-popup {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100vw;
  @media screen and (max-width: 800px) {
    .qr-inner {
      min-width: 330px;
    }
  }
}
.qr-inner {
  max-width: 480px;
  width: 90vw;
  max-height: 90vh;
  margin-top: 20px;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  background: #FFFFFF;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}
.content {
  gap: 16px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.title {
  color: #2c3e50;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  text-align: left;
  flex-shrink: 0;
}
.preview_wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}
.preview_img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  display: block;
  object-fit: contain;
}
.actions {
  gap: 12px;
  flex-shrink: 0;
}
.this_button {
  font-size: 1.17em;
  font-weight: 700;
  border-radius: 5px;
}
.grey_text {
  color: #2c3e50;
}
</style>
